// extracted by mini-css-extract-plugin
module.exports = {"carImageHeader":"CarImageHeader-module--carImageHeader--3YWZO"};